import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {downloadSectionContent} from 'src/openapi/admin/apis/SectionsContentApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    sectionId: number,
    conferenceId: number,
};

export const useDownloadSectionContent = ({sectionId, conferenceId}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(() => apiDispatch(
        downloadSectionContent({sectionId, conferenceId}),
    ), [sectionId, conferenceId, apiDispatch]);

    return useCommonEventHook({eventAction});
};
